export default "__VITE_ASSET__Dr$CmrUl__"